import { createRouter, createWebHistory } from 'vue-router'
import { useAppStore, useAuthStore } from '../stores';

import ResourcesActivities from '../views/ResourcesActivities.vue'
import AssessmentReview from '../views/AssessmentReview.vue'
import Family from '../views/Family.vue'
import Resources from '../views/Resources.vue'
import Home from '../views/Home.vue'
import ResourcesReadinessGuide from '../views/ResourcesReadinessGuide.vue'
import ResourcesGuides from '../views/ResourcesGuides.vue'
import Login from '../views/Login.vue'
import PasswordReset from '../views/PasswordReset.vue'
import Child from '../views/Child.vue'
import Children from '../views/Children.vue'
import MilestoneAssessment from '../views/MilestoneAssessment.vue'

import ReadinessReportCard from '../views/ReadinessReportCard.vue'
import Account from '../views/Account.vue'
import Contracts from '../views/Contracts.vue'
import Contract from '../views/Contract.vue'

import Readiness from '../views/Readiness.vue'
import ReadinessEnrollment from '../views/ReadinessEnrollment.vue'
import AppUnderConstruction from '../views/AppUnderConstruction.vue'

// TODO: update nested paths with parent

export const router = createRouter({
  // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
  history: createWebHistory(),
  routes: [
    { path: '/', component: Home },
    { path: '/resources', component: Resources },
    { path: '/resources/guides/:id', component: ResourcesReadinessGuide },
    // { path: '/resources/activities', component: AppUnderConstruction },
    { path: '/resources/activities', component: ResourcesActivities },
    { path: '/resources/guides', component: ResourcesGuides },
    { path: '/readiness/', component: Readiness },
    { path: '/readiness/report-card/:id', component: ReadinessReportCard },
    { path: '/readiness/assessments/:id', component: MilestoneAssessment },
    { path: '/readiness/assessments/:id/show', component: AssessmentReview },
    { path: '/readiness/enrollment', component: ReadinessEnrollment },
    // { path: '/calendar', component: CalendarLayout },
    { path: '/calendar', component: AppUnderConstruction },
    { path: '/account', component: Account },
    { path: '/contracts', component: Contracts },
    { path: '/contracts/:id', component: Contract },
    { path: '/account/family', component: Family },
    { path: '/account/child/:id', component: Child },
    { path: '/account/child/new', component: Child },
    { path: '/children', component: Children },
    { path: '/login', component: Login },
    { path: '/password_reset', component: PasswordReset },
    // { path: '/assessments/:id', component: MilestoneAssessment },
    // { path: '/assessments', component: Assessments },
  ], // short for `routes: routes`
})

router.beforeEach(async (to) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/signup', '/password_reset'];
  const authRequired = !publicPages.includes(to.path);

  const authStore = useAuthStore();
  const appStore = useAppStore();
  if (authRequired && !authStore.authToken) {
    authStore.returnUrl = to.fullPath;
    appStore.showHeaderChildPicker = false;
    appStore.showAccountFeatures = false;
    return '/login';
  }
  if (to.path.includes('resources')) {
    appStore.headerTitle = 'Resources';
  } else if (to.path.includes('readiness')) {
    appStore.headerTitle = 'Readiness Academy';
  } else if (to.path.includes('calendar')) {
    appStore.headerTitle = 'Calendar';
  } else if (to.path.includes('account')) {
    appStore.headerTitle = 'Account';
  } else {
    appStore.headerTitle = 'Readiness Academy';
  }

  if (publicPages.includes(to.path)) {
    appStore.showHeaderChildPicker = false;
    appStore.showAccountFeatures = false;
    appStore.headerTitle = '';
  } else {
    appStore.showAccountFeatures = true;
  } 

  // if (to.path.includes('readiness')) {
  const childPickerPages = ['/readiness/',]
  if (to.matched[0] && childPickerPages.includes(to.matched[0].path)) {
    appStore.showHeaderChildPicker = true;
  } else {
    appStore.showHeaderChildPicker = false;
  }
  // set Header title
  // toggle showChildPicker
});